import { render, staticRenderFns } from "./TrueNinja.vue?vue&type=template&id=1abd843e&scoped=true&"
import script from "./TrueNinja.vue?vue&type=script&lang=js&"
export * from "./TrueNinja.vue?vue&type=script&lang=js&"
import style0 from "./TrueNinja.vue?vue&type=style&index=0&id=1abd843e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abd843e",
  null
  
)

component.options.__file = "TrueNinja.vue"
export default component.exports